<template>
  <div @wheel="handleWheel">
    <!-- {{ menuState }} -->
    <PCNavbar class="menuDivHome" selectIndex="1" :class="menuState == 'down'?'scrollDownCss':'scrollUpCss'" />
    <MobileNavBar :currentActive="0"/>
    <CarouselHome  />
    <FirstHome  />
    <SecondHome  />
    <ThirdHome  />

  <!-- <TourComponent /> -->



    
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/indexHome.vue'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CarouselHome from '@/components/carousel_home/index'
import FirstHome from '@/components/first_home/index'
import SecondHome from '@/components/second_home/index'
import ThirdHome from '@/components/third_home/index'
// import TourComponent from '@/components/TourComponent.vue'




 
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome,
    FirstHome,
    SecondHome,
    ThirdHome,
    // TourComponent
  },
  data() {
    return {
      currentScreen: 1,
      totalScreens: 3,
      menuState:null
    }
  },
   
  methods: {
    
    handleWheel(event) {
     
        // 阻止默认滚动行为（可选）
                    // event.preventDefault();
                   
                    let delta = event.deltaY;
                    let direction = delta < 0 ? 'up' : 'down';
                  if(direction == 'up'){
                    this.menuState='up'
                  }else{
                    this.menuState='down'
                    
                  }
                  
                    // 更新状态
                    this.lastDirection = direction;
                    this.lastDelta = delta;
                    
                    
},

  }
}
</script>

<style lang="scss" scoped>
.el-menu--horizontal>.el-menu-item{
  font-size: 1.1rem;
  color: #ffffff;
}
.scrollUpCss{
  // display: block;
    
   animation: slideUpFadeIn 1s forwards;
}

/* CSS 代码 */
@keyframes slideUpFadeIn {
   
    0% {
       transform: translateY(-100px);
       visibility: hidden;
     
       background-color: rgb(250, 251, 251,0.3);       
    }
    70% {
       
       background-color: rgb(250, 251, 251,0.5);
     }
    100% {
    
 background-color: rgb(250, 251, 251,0);
         transform: translateY(0);
        visibility: visible;
    }
}
.scrollDownCss{
  // display: none;
  animation: slideDownFadeOut 1s forwards;
}

/* CSS 代码 */
@keyframes slideDownFadeOut {
    0% {
        transform: translateY(0);
        opacity: 0;
        visibility: visible;
    }
    70% {
        opacity: 0.3;
    }
    100% {
        transform: translateY(-100px);
        opacity: 0;
        visibility: hidden;
    }
}


 
.menuDivHome{
  background-color:transparent;
 
}
::v-deep{
 .el-menu{
    background-color:transparent;
  }
} 
.bottom_circle {
  width: 100%;
  text-align: center;
  padding-top: 100px;
  background-image: url(../assets/img/smalldot.png),url(../assets/img/smalldot1.png);
  background-position: 0 0,110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;
  h1 {
    font-size: 40px;
    padding-bottom: 20px;
    @media screen and (max-width: 768px) {
      font-size: 1.15rem;
      width: 60%;
      margin: 0 auto;
    }
  }
  .circle_img {
    width: 100%;
    img {
      width: 70%;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin: 20PX 0;
      }
    }
  }
}
</style>